import { createContext } from 'react';
import { GetOrganizationQuery, GetUserQuery } from 'data/__generated__';

export interface UserContextType {
    user: GetUserQuery['user'] | null;
    organization: GetOrganizationQuery['organizationOfUser'] | null;
}

export const UserContext = createContext<UserContextType>({
    user: null,
    organization: null,
});
